import template from './topdata-login-attempt-log-list.html.twig';
import './topdata-login-attempt-log-list.scss';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;
const { date } = Shopware.Utils.format;
const { Application } = Shopware;

Shopware.Component.register('topdata-login-attempt-log-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('listing'),
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            sortBy: 'createdAt',
            sortDirection: 'DESC',
            naturalSorting: false,
            total: 0,
            filterAttemptType: null,
            filterSuccess: null,
            emailSearchTerm: '',
            emailSearchTimeout: null,
            showClearModal: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_login_attempt_log');
        },

        attemptTypeOptions() {
            return [
                { value: null, label: this.$tc('global.default.all') },
                { value: 'login', label: this.$tc('TopdataContactLoginSW6.loginLog.attemptType.login') },
                { value: 'contact_login', label: this.$tc('TopdataContactLoginSW6.loginLog.attemptType.contact_login') },
                { value: 'password_reset_request', label: this.$tc('TopdataContactLoginSW6.loginLog.attemptType.password_reset_request') },
                { value: 'password_reset', label: this.$tc('TopdataContactLoginSW6.loginLog.attemptType.password_reset') },
            ];
        },

        successOptions() {
            return [
                { value: null, label: this.$tc('global.default.all') },
                { value: '1', label: this.$tc('TopdataContactLoginSW6.loginLog.success.1') },
                { value: '0', label: this.$tc('TopdataContactLoginSW6.loginLog.success.0') },
            ];
        },

        columns() {
            return [
                {
                    property: 'email',
                    label: this.$tc('TopdataContactLoginSW6.loginLog.list.column.email'),
                    allowResize: true,
                    primary: true,
                },
                {
                    property: 'attemptType',
                    label: this.$tc('TopdataContactLoginSW6.loginLog.list.column.attemptType'),
                    allowResize: true,
                },
                {
                    property: 'success',
                    label: this.$tc('TopdataContactLoginSW6.loginLog.list.column.success'),
                    allowResize: true,
                },
                {
                    property: 'errorMessage',
                    label: this.$tc('TopdataContactLoginSW6.loginLog.list.column.errorMessage'),
                    allowResize: true,
                    visible: false,
                },
                {
                    property: 'createdAt',
                    label: this.$tc('TopdataContactLoginSW6.loginLog.list.column.createdAt'),
                    allowResize: true,
                },
            ];
        },
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));
            criteria.addAssociation('customer');

            const emailTerm = this.emailSearchTerm ? this.emailSearchTerm.trim() : '';
            if (emailTerm) {
                criteria.addFilter(Criteria.contains('email', emailTerm));
            }

            if (this.filterAttemptType) {
                criteria.addFilter(Criteria.equals('attemptType', this.filterAttemptType));
            }

            if (this.filterSuccess !== null && this.filterSuccess !== '') {
                criteria.addFilter(Criteria.equals('success', parseInt(this.filterSuccess, 10)));
            }

            return this.repository.search(criteria, Shopware.Context.api).then((result) => {
                this.items = result;
                this.total = result.total;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onEmailSearchInput() {
            if (this.emailSearchTimeout) {
                clearTimeout(this.emailSearchTimeout);
            }
            this.emailSearchTimeout = setTimeout(() => {
                this.page = 1;
                this.getList();
            }, 300);
        },

        onFilterChanged() {
            this.page = 1;
            this.getList();
        },

        beforeDestroy() {
            if (this.emailSearchTimeout) {
                clearTimeout(this.emailSearchTimeout);
            }
        },

        getAttemptTypeLabel(attemptType, contactId, customerId) {
            if (attemptType === 'login') {
                if (contactId) {
                    return this.$tc('TopdataContactLoginSW6.loginLog.attemptType.contact_login');
                }
                if (customerId) {
                    return this.$tc('TopdataContactLoginSW6.loginLog.attemptType.login_success_customer');
                }
                return this.$tc('TopdataContactLoginSW6.loginLog.attemptType.login');
            }
            return this.$tc(`TopdataContactLoginSW6.loginLog.attemptType.${attemptType}`, 0, attemptType);
        },

        getSuccessVariant(success) {
            return success ? 'success' : 'danger';
        },

        getSuccessLabel(success) {
            return success
                ? this.$tc('TopdataContactLoginSW6.loginLog.success.1')
                : this.$tc('TopdataContactLoginSW6.loginLog.success.0');
        },

        getErrorMessageLabel(errorMessage) {
            const key = `TopdataContactLoginSW6.loginLog.errorMessage.${errorMessage}`;
            const translated = this.$tc(key, 0, errorMessage);
            return translated !== key ? translated : errorMessage;
        },

        formatDate(value) {
            if (!value) {
                return '';
            }
            return date(value, {
                hour: '2-digit',
                minute: '2-digit',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },

        onClear() {
            this.showClearModal = true;
        },

        onConfirmClear() {
            this.showClearModal = false;
            this.isLoading = true;

            const httpClient = Application.getContainer('init').httpClient;
            httpClient.post('_action/topdata-contact-login-sw6/login-log/clear', {})
                .then(() => {
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataContactLoginSW6.loginLog.list.clearSuccess'),
                    });
                    this.getList();
                })
                .catch(() => {
                    this.createNotificationError({
                        message: this.$tc('TopdataContactLoginSW6.loginLog.list.clearError'),
                    });
                    this.isLoading = false;
                });
        },

        onCancelClear() {
            this.showClearModal = false;
        },

        onDownloadCsv() {
            const httpClient = Application.getContainer('init').httpClient;
            httpClient.get('_action/topdata-contact-login-sw6/login-log/export', {
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'login-activity-log.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(() => {
                this.createNotificationError({
                    message: this.$tc('TopdataContactLoginSW6.loginLog.list.exportError'),
                });
            });
        },
    },
});
